import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle maintenance notification context enum
 * @description Notification contexts specific to vehicle maintenance subjects
 */
export enum VehicleMaintenanceNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle maintenance-specific contexts
	PENDING = 'pending',
	IN_PROGRESS = 'in_progress',
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
}
